import { StyledLink } from './subject.styled';

export const Subject = ({ id, subject }: { id: string; subject: string }) => {
  return (
    <div style={{ paddingLeft: '10px' }}>
      <StyledLink to={`/invite-listing/${id}`} target="_blank">
        {subject}
      </StyledLink>
    </div>
  );
};
